// const Qs = require('qs')
class HttpUtil {
    constructor(){

    }
    request(params){
        params.isnologin=params.isnologin||false;
        let token = window.localStorage.getItem('token');
        let language = window.localStorage.getItem('lang')
        // if(!token && !params.isnologin){
        //     params.that.$router.push({path:'/login'})
        // }else {
            let url = params.url;
            let data = params.data;
            let method = params.method || 'POST';
           // console.log(url+"="+method);
            let args = {
                method: method,
                url: url,
                data:data,
                // data:Qs.stringify(data),
                headers:{
                    'Content-Type':'application/json;charset=UTF-8',
                    // 'Content-Type':'application/x-www-form-urlencoded',
                    // Authorization : "Bearer "+token
                    'Accept-Language': language,
                    Authorization : token ? "Bearer "+token : ''
                },
            }
            if(params.responseType){
                args.responseType = params.responseType;
            }
            params.that.$axios(args).then(response => {
                // console.log({response,responseType:params.responseType})
                if(params.responseType){
                    params.cb(response);
                }
                else if(response.code==1009){

                    // params.that.$router.push({path:'/'})
                }
                else {
                    params.cb(response.data);
                }

            }).catch(error => {
                console.log(error)
            }).finally(() => {
                if (params.finally && typeof params.finally === 'function') {
                    params.finally();
                }
            })
        // }
    }

}
export  default  new HttpUtil()